import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';
import { WebinarsService } from '../webinars.service';

@Component({
  selector: 'app-webinars',
  templateUrl: './webinars.component.html',
  styleUrls: ['./webinars.component.css']
})
export class WebinarsComponent implements OnInit {

  //declare variables
  webinars: any[] = [];
  filtered: any[] = [];
  strSearch: string = '';

  //inject services
  constructor(private mds: MetaService, private webs: WebinarsService) { }

  //initialize the component
  ngOnInit(): void {
    //get the regulations
    this.webinars = this.webs.getWebinars();
    //filter them
    this.sort(this.webinars);

    //SEO Optimization
    var strTitle = 'RegScale - Webinars';
    var description = 'RegScale list of online webinars';
    var keywords = 'RegScale, compliance, webinars';
    this.mds.updateTags(strTitle, keywords, description);
  }

  //filters catalogs based on user search criteria
  filter() {
    this.webinars = this.webs.getWebinars();
    var search = this.strSearch.toLowerCase();
    if (this.strSearch == '') {
      //reset to all records
      this.sort(this.webinars);
    } else {
      this.webinars = this.webinars.filter(t => t.title.toLowerCase().indexOf(search) > -1);
      this.sort(this.webinars);
    }
  }

  //sort the array
  sort(array: any[]) {
    this.filtered = array.sort(function (a, b) {
      var firstValue = a.title.toLowerCase();
      var secondValue = b.title.toLowerCase();
      if (firstValue < secondValue) {
        return -1;
      } else {
        return 1;
      }
    });
  }

}
